#import "../fragments/paymentMethods.gql"

query getAllPaymentMethods {
  payments {
    topUp {
      ...PaymentMethods
    }
    withdraw {
      ...PaymentMethods
    }
  }
}
